import { render } from "./CSkatMastersHeader.vue?vue&type=template&id=3b96085b&scoped=true"
const script = {}

import "./CSkatMastersHeader.vue?vue&type=style&index=0&id=3b96085b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b96085b"]])

export default __exports__